import { createSlice } from '@reduxjs/toolkit';
import {PatientCardData} from "./PatientCardData";

const PatientCardSlice = createSlice({
    name: 'main',
    initialState: PatientCardData,
    reducers: {
        addItem: (state, action) => {
            state.push(action.payload);
        },
    },
});

export const { addItem } = PatientCardSlice.actions;
export default PatientCardSlice;